export const removeIdPrefix = (id: string) => {
  if (!id) return '';
  return id.split('_')[1];
};
